import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {GoalLeadValueIcon} from 'shells/icon/svg/goal-lead-value-icon';

import styles from './banner.module.css';

type Props = {
    width: number;
    onClick: () => void;
};

export function SAGoalsCtaBanner(props: Props) {
    return (
        <div style={{width: props.width}} className={styles['banner-container']}>
            <CTABanner
                icon={GoalLeadValueIcon}
                title='Set goals for each stage of your pipeline'
                text='Use goals to set milestones and track your pipeline progress.'
                buttonText='Get started'
                maxWidth={null}
                onPrimaryAction={props.onClick}
            />
        </div>
    );
}
